import { gql } from 'graphql-request';

export default gql`
  fragment ActivityPrice on ActivityPrice {
    tickets {
      ... on ActivityTicketBlock {
        id
        title
        price
        url
      }
    }
  }
`;
